"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IncreaseReduceButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(() => ({
  root: {
    padding: '6px 16px',
    borderRadius: 4
  }
}));
const IncreaseReduceButton = _ref => {
  let {
    handleIncrease,
    handleDecrease,
    disableIncrease,
    disableDecrease
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    "aria-label": "reduzir",
    onClick: handleIncrease,
    disabled: disableIncrease,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Remove.default, {
    fontSize: "small"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    "aria-label": "aumentar",
    onClick: handleDecrease,
    disabled: disableDecrease,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    fontSize: "small"
  })));
};
exports.IncreaseReduceButton = IncreaseReduceButton;
IncreaseReduceButton.propTypes = {
  /*
   * Função a ser executada quando o botão `+` for acionado
   */
  handleIncrease: _propTypes.default.func.isRequired,
  /*
   *  Função a ser executada quando o botão `-` for acionado
   */
  handleDecrease: _propTypes.default.func.isRequired,
  /*
   * Valor booleano que representa se o botão `+` está ou não desabilitado
   */
  disableIncrease: _propTypes.default.bool,
  /*
   *  Valor booleano que representa se o botão `-` está ou não desabilitado
   */
  disableDecrease: _propTypes.default.bool
};
IncreaseReduceButton.defaultProps = {
  disableIncrease: false,
  disableDecrease: false
};